import { render, staticRenderFns } from "./CarouselProductHoverCard.vue?vue&type=template&id=532bcd88"
import script from "./CarouselProductHoverCard.vue?vue&type=script&lang=js"
export * from "./CarouselProductHoverCard.vue?vue&type=script&lang=js"
import style0 from "./CarouselProductHoverCard.vue?vue&type=style&index=0&id=532bcd88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports